import React from "react";

const WelcomeCard = () => {
  return (
    <section className="mb-6">
      <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-4 md:p-6 ">
        <h2 className="text-lg md:text-xl font-semibold text-gray-900">
          Welcome back 👋
        </h2>
        <p className="text-sm text-gray-500 mt-1">
          Here’s a quick snapshot of what’s happening today.
        </p>
      </div>
    </section>
  );
};

export default WelcomeCard;
